import React, { useState, Component, useContext } from "react";
import moment from "moment";
import API from "../../../apiService";
import "react-datepicker/dist/react-datepicker.css";
import AdminView from "./AdminView";
import Profile from "./profile";
import VerifikasiRumahMakan from "./verifikasi/VerifikasiRumahMakan";
import VerifikasiJasaBoga from "./verifikasi/VerifikasiJasaBoga";
import VerifikasiHotel from "./verifikasi/VerifikasiHotel";
import PenilaianRumahMakan from "./penilaian/PenilaianRumahMakan";
import PenilaianJasaBoga from "./penilaian/PenilaianJasaBoga";
import PenilaianHotel from "./penilaian/PenilaianHotel";
import printJS from "print-js";
import apiService from "../../../apiService";
import { BASE_URL } from "constants/baseURL";
import Swal from "sweetalert2";
import swal from "sweetalert";

export const AdminContext = React.createContext({});

const hotelFetch = async (params) => {
  try {
    const response = await API.post("/hotel/registration/read", {
      id: null,
      date_from: params.frDate,
      date_to: params.enDate,
    });
    return response.data;
  } catch (error) {
    return [];
  }
};

const departmentSearch = async (params, flag) => {
  try {
    const response = await API.post("/department/search", {
      id: null,
      start_date: params.frDate,
      end_date: params.enDate,
      ref_jenis_id: flag,
    });
    return response.data;
  } catch (error) {
    return [];
  }
};

const Admin = () => {
  const [datas, setDatas] = useState([]);
  const [selectedData, setSelectedData] = useState("");
  const [contextData, setContextData] = useState({});
  const [type, setType] = useState("1");
  const [formKey, setFormKey] = useState("");
  const [isShow, setIsShow] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [frDate, setFrDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [enDate, setEnDate] = useState(moment(new Date()).format("YYYY-MM-DD"));

  const fetch = async (value) => {
    switch (value.type) {
      case "1":
        return await departmentSearch(value, value.type);
      case "2":
        return await departmentSearch(value, value.type);
      case "3":
        return await hotelFetch(value, value.type);
      default:
        break;
    }
  };

  const showVerificationForm = (index, data) => {
    switch (parseInt(index)) {
      case 1:
        setSelectedData(data);
        setFormKey("VER_RM");
        setIsShow(false);
        break;
      case 2:
        setSelectedData(data);
        setFormKey("VER_JB");
        setIsShow(false);
        break;
      case 3:
        setSelectedData(data);
        setFormKey("VER_HT");
        setIsShow(false);
        break;
      default:
        break;
    }
  };

  const showPenilaianForm = (index, data) => {
    switch (parseInt(index)) {
      case 1:
        setSelectedData(data);
        setFormKey("PNLN_RM");
        setIsShow(false);
        break;
      case 2:
        setSelectedData(data);
        setFormKey("PNLN_JB");
        setIsShow(false);
        break;
      case 3:
        setSelectedData(data);
        setFormKey("PNLN_HT");
        setIsShow(false);
        break;
      default:
        break;
    }
    console.log(selectedData);
  };

  const backHome = () => {
    setContextData({});
    setIsShow(true);
    setFormKey("-");
    setType("1");
    setDatas([]);
  };

  const handleSelectChange = (e) => setType(e.target.value);
  const handleSubmit = async (e, values) => {
    e.preventDefault();
    setIsLoading(true);
    const result = await fetch(values);
    if (result) {
      setDatas(result);
      setIsLoading(false);
    }
  };

  const requestCertificate = async (url, id, flag) => {
    const res = await API.getblob(url);
    if (res) {
      const cek = new Blob([res], { type: "application/pdf" }).size;
      if (cek > 100) {
        const file = new Blob([res], { type: "application/pdf" });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //print blob
        printJS(fileURL);
      } else {
        const { value: formValues } = await Swal.fire({
          title: "Masukan data Pendukung",
          html:
            '<input id="swal-input1" placeholder = "nomor sertifikat" value="" class="swal2-input">' +
            '<input id="swal-input2" type="date" placeholder = "Tanggal TTD Sertifikat" value="" class="swal2-input">' +
            '<input id="swal-input3" type="date" placeholder = "Masa Berlaku sertifikat" value="" class="swal2-input">',
          focusConfirm: false,
          type: "warning",
          showCancelButton: true,
          cancelButtonColor: "grey",
          confirmButtonText: "Update!",
          allowOutsideClick: false,
          preConfirm: () => ({
            certificate: document.getElementById("swal-input1").value,
            start_date: document.getElementById("swal-input2").value,
            end_date: document.getElementById("swal-input3").value,
          }),
        });
        if (formValues) {
          if (
            formValues.certificate !== "" &&
            formValues.star_date !== "" &&
            formValues.end_date !== ""
          ) {
            let urlUpdate = `${API.service.defaults.baseURL}/department/certificate_number/create`;
            let url2 = `${API.service.defaults.baseURL}/department/certificate_date/create`;

            let param = {
              registration_id: id,
              certificate_number: formValues.certificate,
              flags: 1,
              status: 1,
            };
            let param2 = {
              registration_id: id,
              start_date: formValues.start_date,
              end_date: formValues.end_date,
              flags: 1,
              status: 1,
            };
            postCertificate(url, urlUpdate, param, param2, url2);
          } else {
            Swal.fire({
              title: "Data Harus diisi Lengkap",
              type: "danger",
              customClass: {
                confirmButton: "btn btn-danger",
              },
            });
          }
        }
      }
    }
  };
  const requestCertificateEdit = async (url, id, flag) => {
    const { value: formValues } = await Swal.fire({
      title: "Masukan data Pendukung",
      html:
        '<input id="swal-input1" placeholder = "nomor sertifikat" value="" class="swal2-input">' +
        '<input id="swal-input2" type="date" placeholder = "Tanggal TTD Sertifikat" value="" class="swal2-input">' +
        '<input id="swal-input3" type="date" placeholder = "Masa Berlaku sertifikat" value="" class="swal2-input">',
      focusConfirm: false,
      type: "warning",
      showCancelButton: true,
      cancelButtonColor: "grey",
      confirmButtonText: "Update!",
      allowOutsideClick: false,
      preConfirm: () => ({
        certificate: document.getElementById("swal-input1").value,
        start_date: document.getElementById("swal-input2").value,
        end_date: document.getElementById("swal-input3").value,
      }),
    });
    if (formValues) {
      if (
        formValues.certificate !== "" &&
        formValues.star_date !== "" &&
        formValues.end_date !== ""
      ) {
        let urlUpdate = `${API.service.defaults.baseURL}/department/certificate_number/create`;
        let url2 = `${API.service.defaults.baseURL}/department/certificate_date/create`;

        let param = {
          registration_id: id,
          certificate_number: formValues.certificate,
          flags: 1,
          status: 1,
        };
        let param2 = {
          registration_id: id,
          start_date: formValues.start_date,
          end_date: formValues.end_date,
          flags: 1,
          status: 1,
        };
        postCertificate(url, urlUpdate, param, param2, url2);
      } else {
        Swal.fire({
          title: "Data Harus diisi Lengkap",
          type: "danger",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        });
      }
    }
  };

  const postCertificate = async (url, urlUpdate, param, param2, url2) => {
    let res1 = await API.post(urlUpdate, param);
    if (res1.code === 200) {
      let res2 = await API.post(url2, param2);
      if (res2.code === 200) {
        requestCertificate1(url, param.registration_id);
      }
    }
  };

  const requestCertificate1 = async (url, id) => {
    const res = await API.getblob(url);
    if (res) {
      const file = new Blob([res], { type: "application/pdf" });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //print blob
      printJS(fileURL);
    }
  };

  const print = async (id, typeArgs) => {
    switch (typeArgs) {
      case "1":
        requestCertificate(`/department/print/${id}`, id);
        break;
      case "2":
        requestCertificate(`/department/print/${id}`, id);
        break;
      case "3":
        requestCertificate(`/hotel/registration/print/${id}`, id);
        break;
      default:
        break;
    }
  };

  const printEdit = async (id, typeArgs) => {
    switch (typeArgs) {
      case "1":
        requestCertificateEdit(`/department/print/${id}`, id);
        break;
      case "2":
        requestCertificateEdit(`/department/print/${id}`, id);
        break;
      case "3":
        requestCertificateEdit(`/hotel/registration/print/${id}`, id);
        break;
      default:
        break;
    }
  };

  const cekPenilaian = (data) => {};

  function renderComponent(name, data) {
    switch (name) {
      case "VER_RM":
        return <VerifikasiRumahMakan backHome={backHome} data={data} />;
      case "VER_JB":
        return <VerifikasiJasaBoga backHome={backHome} data={data} />;
      case "VER_HT":
        return <VerifikasiHotel backHome={backHome} data={data} />;
      case "PNLN_RM":
        return <PenilaianRumahMakan backHome={backHome} data={data} />;
      case "PNLN_JB":
        return <PenilaianJasaBoga backHome={backHome} data={data} />;
      case "PNLN_HT":
        return <PenilaianHotel backHome={backHome} data={data} />;
      default:
        return "";
    }
  }

  const dateOnChange = (date, flag) =>
    flag === "fr" ? setFrDate(date) : setEnDate(date);

  const frDateToDate = moment(frDate).toDate();
  const enDateToDate = moment(enDate).toDate();

  return (
    <>
      <AdminContext.Provider value={{ contextData, setContextData }}>
        <AdminView
          values={{ frDate, enDate, type }}
          showPenilaianForm={showPenilaianForm}
          showVerificationForm={showVerificationForm}
          lists={datas}
          date={{ frDate: frDateToDate, enDate: enDateToDate }}
          dateOnChange={dateOnChange}
          handleSelectChange={handleSelectChange}
          handleSubmit={handleSubmit}
          isShow={isShow}
          isLoading={isLoading}
          print={print}
          printEdit={printEdit}
        />
        <Profile backHome={backHome} isShow={!isShow} data={selectedData} />
        {renderComponent(formKey, selectedData)}
      </AdminContext.Provider>
    </>
  );
};

export default Admin;
